import gql from 'graphql-tag';

/**
 * Query to fetch a category by slug along with its associated posts.
 *
 * @param slug - The category slug identifier
 * @param cursor - Pagination options for the posts list (limit, skip)
 * @returns Category details (name, description) and paginated list of posts with images, authors, and categories
 * @usedIn Category page layout
 */
export const CATEGORY_WITH_POSTS = gql`
  query category($slug: String, $cursor: PagniationOptions) {
    category(slug: $slug, postsCursor: $cursor) {
      name
      description
      posts {
        title
        slug
        image {
          sourceUrl
          sourceSet
        }
        type
        publishedAt
        authors {
          displayName
          preferredUsername
        }
        categories {
          name
          slug
        }
      }
    }
  }
`;
